import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ConfigDocumentType {
  id: number;
  name: string;
  label: string;
}

export interface ConfigDocument {
  id: number;
  name: string;
  description: string;
  configDocumentType: ConfigDocumentType;
  companyId: number;
  createdAt: string;
  updatedAt: string;
}

export type ConfigDocTypeEnums = Record<string, ConfigDocumentType>;

export interface TabItem {
  id: string;
  label: string;
  orderId: number;
}

interface ConfigDocumentsState {
  configDocTypeEnums: ConfigDocTypeEnums | null;
  tabs: TabItem[];
  configurationDocuments: ConfigDocument[];
}

const initialState: ConfigDocumentsState = {
  configDocTypeEnums: null,
  tabs: [],
  configurationDocuments: [],
};

const configDocumentsSlice = createSlice({
  name: 'configDocuments',
  initialState,
  reducers: {
    setConfigDocTypeEnumsAction(state, action: PayloadAction<ConfigDocTypeEnums>) {
      state.configDocTypeEnums = action.payload;
    },
    setTabsAction(state, action: PayloadAction<TabItem[]>) {
      state.tabs = action.payload;
    },
    setConfigurationDocumentsAction(state, action: PayloadAction<ConfigDocument[]>) {
      state.configurationDocuments = action.payload;
    },
    createConfigurationDocumentAction(state, action: PayloadAction<ConfigDocument>) {
      state.configurationDocuments.push(action.payload);
    },
    updateConfigurationDocumentAction(state, action: PayloadAction<ConfigDocument>) {
      state.configurationDocuments = state.configurationDocuments.map(document =>
        document.id === action.payload.id ? action.payload : document,
      );
    },
    deleteConfigurationDocumentAction(state, action: PayloadAction<number>) {
      state.configurationDocuments = state.configurationDocuments.filter(document => document.id !== action.payload);
    },
  },
});

export const {
  setConfigDocTypeEnumsAction,
  setTabsAction,
  setConfigurationDocumentsAction,
  createConfigurationDocumentAction,
  updateConfigurationDocumentAction,
  deleteConfigurationDocumentAction,
} = configDocumentsSlice.actions;
export default configDocumentsSlice.reducer;
